import { useEffect, useRef, useState } from "react";
import { formatVestaDate, normalizeVestaDateInput, sanitizeVestaDateEntry, toIsoVestaDate } from "../../utils/dateInput";

function outputValue(formatted, outputFormat) {
  if (!formatted) return "";
  return outputFormat === "iso" ? toIsoVestaDate(formatted) : formatted;
}

export default function VestaDateInput({
  value = "",
  onChange,
  outputFormat = "display",
  placeholder = "gg/mm/aaaa",
  disabled = false,
  readOnly = false,
  required = false,
  className = "",
  inputClassName = "",
  ariaLabel,
  id,
  name,
}) {
  const pickerRef = useRef(null);
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(() => formatVestaDate(value));

  useEffect(() => {
    if (!editing) setDraft(formatVestaDate(value));
  }, [editing, value]);

  function beginEditing() {
    setEditing(true);
    setDraft(sanitizeVestaDateEntry(formatVestaDate(value) || value));
  }

  function commitDraft() {
    const formatted = normalizeVestaDateInput(draft);
    const nextValue = outputValue(formatted, outputFormat);
    setEditing(false);
    setDraft(formatted);
    if (String(nextValue) !== String(value || "")) onChange?.(nextValue);
  }

  function chooseCalendarValue(event) {
    const formatted = formatVestaDate(event.target.value);
    setEditing(false);
    setDraft(formatted);
    onChange?.(outputValue(formatted, outputFormat));
  }

  const displayValue = editing ? draft : (formatVestaDate(value) || "");
  const pickerValue = toIsoVestaDate(editing ? draft : value);

  return (
    <div className={`overlay_input_action_wrap vesta_date_control${className ? ` ${className}` : ""}`}>
      <input
        id={id}
        name={name}
        className={`vesta_date_text_input${inputClassName ? ` ${inputClassName}` : ""}`}
        inputMode="numeric"
        autoComplete="off"
        value={displayValue}
        placeholder={placeholder}
        maxLength={8}
        disabled={disabled}
        readOnly={readOnly}
        required={required}
        aria-label={ariaLabel}
        aria-readonly={readOnly || undefined}
        onFocus={readOnly ? undefined : beginEditing}
        onChange={readOnly ? undefined : (event) => setDraft(sanitizeVestaDateEntry(event.target.value))}
        onBlur={readOnly ? undefined : commitDraft}
      />
      <input
        ref={pickerRef}
        className="overlay_hidden_date_picker"
        type="date"
        value={pickerValue}
        disabled={disabled || readOnly}
        onChange={chooseCalendarValue}
        tabIndex={-1}
        aria-hidden="true"
      />
      <button
        type="button"
        className="overlay_embedded_action_button overlay_calendar_action_button vesta_date_calendar_button"
        onMouseDown={(event) => event.preventDefault()}
        onClick={() => pickerRef.current?.showPicker?.() || pickerRef.current?.click()}
        aria-label="Apri calendario"
        disabled={disabled || readOnly}
        tabIndex={-1}
      >
        <svg viewBox="0 0 24 24" aria-hidden="true" className="overlay_calendar_icon">
          <rect x="3.75" y="5.25" width="16.5" height="15" rx="3" />
          <path d="M7.5 3.5v3.5M16.5 3.5v3.5M4.25 9.25h15.5" />
          <path d="M8 12.75h.01M12 12.75h.01M16 12.75h.01M8 16.25h.01M12 16.25h.01M16 16.25h.01" />
        </svg>
      </button>
    </div>
  );
}
